import { ChatBot, NextPage, NextPageHead, OfficeLocationContextProvider, PageThemeContextProvider, PageView } from '@src/lib/shared-components-web';
import { describeContentfulError, throwIfContentfulUnavailable } from '@utils/pages/contentful-errors';
import DetermineIndexing from '@utils/pages/determine-indexing';
type BuildPageConfigInput = {
  brandConfig: any;
  facilityDetailsBasePath: string;
  appData: any;
  transformedServices: any;
  req: any;
};
type GetAppDataInput = {
  appPagesData: any;
  appMetadata: any;
  logger: any;
  appPagesWarningContext: string;
  appMetadataErrorContext?: string;
};
type LocationDirectoryPageShellProps = {
  appData: any;
  page: any;
  config: any;
  cities: any;
  breadcrumbsData: any;
  pageReferrer: string;
  domain: string;
  preview: boolean;
  env: any;
};
export const resolveFacilityDetailsBasePath = (brandConfig: any) => {
  return brandConfig.features.otherApps.facilityDetailsBasePath === 'doctors' ? 'locations' : brandConfig.features.otherApps.facilityDetailsBasePath;
};
export const applyEnvToLocationBarFindOfficeUrl = (appData: any) => {
  if (!appData?.header?.locationBarFindOfficeUrl) {
    return;
  }
  const brandSubdomain = process.env.ENVIRONMENT_NAME === 'prod' ? 'www' : 'wwwstg';
  appData.header.locationBarFindOfficeUrl = appData.header?.locationBarFindOfficeUrl?.replace('[env]', brandSubdomain);
};
export const buildPageConfig = ({
  brandConfig,
  facilityDetailsBasePath,
  appData,
  transformedServices,
  req
}: BuildPageConfigInput) => {
  return {
    ...brandConfig,
    features: {
      ...brandConfig.features,
      otherApps: {
        ...brandConfig.features.otherApps,
        facilityDetailsBasePath
      }
    },
    ...(appData.featureFlags ? {
      featureFlags: appData.featureFlags
    } : {}),
    services: transformedServices,
    schemaUrl: `${brandConfig.siteURL}${req.url}`
  };
};
export const getAppData = ({
  appPagesData,
  appMetadata,
  logger,
  appPagesWarningContext,
  appMetadataErrorContext = 'CONTENTFUL_ERROR'
}: GetAppDataInput) => {
  throwIfContentfulUnavailable(appPagesData, appPagesWarningContext);
  throwIfContentfulUnavailable(appMetadata, appMetadataErrorContext);
  if (appPagesData.error) {
    logger.warn(`${appPagesWarningContext}: ${describeContentfulError(appPagesData.error)}`);
  }
  if (appMetadata.error) {
    logger.warn(`${appMetadataErrorContext}: ${describeContentfulError(appMetadata.error)}`);
  }
  const appData = {
    ...appPagesData.data?.appCollection?.items[0],
    ...appMetadata.data?.appCollection?.items[0]
  };
  applyEnvToLocationBarFindOfficeUrl(appData);
  return appData;
};
export const LocationDirectoryPageShell = ({
  appData,
  page,
  config,
  cities,
  breadcrumbsData,
  pageReferrer,
  domain,
  preview,
  env
}: LocationDirectoryPageShellProps) => {
  const {
    url: logoUrl
  } = appData?.logo ?? {};
  const {
    path,
    title,
    indexed,
    description,
    canonical,
    disableChatBot = false,
    analyticsContext,
    ogImage
  } = page;
  const pageTheme = page?.pageTheme || 'Primary';
  const {
    features,
    featureFlags,
    siteURL,
    logo
  } = config as BrandThemeConfig;
  return <PageThemeContextProvider pageTheme={pageTheme} data-sentry-element="PageThemeContextProvider" data-sentry-component="LocationDirectoryPageShell" data-sentry-source-file="location-page-shared.tsx">
			<OfficeLocationContextProvider cities={cities} data-sentry-element="OfficeLocationContextProvider" data-sentry-source-file="location-page-shared.tsx">
				<PageView analyticsContext={analyticsContext} pageReferrer={pageReferrer} siteSection="Office Details" data-sentry-element="PageView" data-sentry-source-file="location-page-shared.tsx" />
				<NextPageHead path={path} title={title} indexed={DetermineIndexing(indexed, env, preview, featureFlags.doNotIndexWholeSite, domain)} description={description} canonical={canonical} breadcrumbTitle={breadcrumbsData?.breadcrumbTitle} breadcrumbs={breadcrumbsData?.breadcrumbsCollection.items} originUrl={siteURL} ogImage={ogImage?.desktopImage?.image?.cdn_url ?? logo.dark} data-sentry-element="NextPageHead" data-sentry-source-file="location-page-shared.tsx" />
				<NextPage pageData={{
        ...page
      }} data-sentry-element="NextPage" data-sentry-source-file="location-page-shared.tsx" />
				{!disableChatBot && <ChatBot url={features.chat.chatBotURL} isIconButton={features.chat.isIconButton} logoUrl={logoUrl} featureList={featureFlags.featureList} />}
			</OfficeLocationContextProvider>
		</PageThemeContextProvider>;
};